export type EbookCreateDto = {
  title: string;
  publishingDate: Date;
  authorId: number;
  priceEUR: string;
  seriesId?: number;
  numberInSeries?: number;
  longDescription?: string;
  hasPrintBook?: boolean;
  printBookIsbn?: string;
};

export type Author = {
  id: number;
  firstName: string;
  lastName: string;
};

export type PriceOption = {
  id: number;
  value: string;
  label: string;
};

export interface ISeriesDto {
  id: number;
  code: string;
  title: string;
}

export interface IEbookNumberInSeriesDto {
  ebookId: number;
  isbn: string;
  numberInSeries: number;
}

export const mapToPriceOptions = (eurPrices: number[]): PriceOption[] =>
  eurPrices.map((eur: number, index: number): PriceOption => {
    const parts: string[] = eur.toFixed(2).split(".");
    return {
      id: index,
      value: eur.toFixed(2),
      label: `${parts[0]},${parts[1]} \u20AC`,
    };
  });